$(document).ready(function () {
   var galleryCheck = $("div.photo_ANP").length;
 
   extensions = ["_pico.", "_icon.", "_thumb.", "_small.", "_compact.", "_medium.", "_large.", "_grande.", "_1024x1024.", "_2048x2048." ];

 if (galleryCheck > 0) {
   gallery = $("div.photo_ANP");
   var images = gallery.find('img');
 
   images.each(function () {
       imgSRC = $(this).attr('src');
       
       for ( var i = 0; i < extensions.length; i++ ){
         var newSRC = imgSRC.replace( extensions[i] ,'.'); 
         if (newSRC.length<imgSRC.length) { break; };
       }
       $(this).wrap('<a href="' + newSRC + '" data-lightbox="gallery" rel="nofollow"></a>');
   });
 }
    
});